import styled from 'styled-components';
import { fonts, colors } from 'stylesheets';

export const Problems = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  &:after {
    content: '';
    flex: auto;
    display: flex;
  }

  max-height: 400px;
  width: 100%;
  padding: 40px 0;
  overflow-y: auto;
  margin-bottom: 20px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${colors.greyLighter};
`;

export const CardProblem = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 30px;

  & ${Row}:not(:last-child) {
    margin-bottom: .5rem;
  }
`;

export const RowTitle = styled.p`
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 4px;
`;

export const RowSubtitle = styled.p`
  font-size: 13px;
  font-family: ${fonts.secondary};
  margin-bottom: 4px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 500px;
`;

export const Img = styled.img`
  width: 454px;
  height: 297px;
  margin: 75px auto 0px auto;
`;
export const Text = styled.p`
  color: ${colors.greyDark};
  text-align: center;
`;
export const Title = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  margin-top: 50px;
`;
export const Description = styled(Text)`
  font-size: 14px;
  font-weight: normal;
  width: 30%;
  margin: 0 auto;
`;
export const Button = styled.button`
  width: 162px;
  height: 34px;
  background: ${colors.white};
  border-radius: 90px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  margin: 17px auto 90px auto;
  font: 10px ${fonts.secondary};
  text-transform: uppercase;
  border: none;
  transition: 0.5s box-shadow;
  cursor: pointer;
  &:active,
  &:focus {
    outline: none;
    border: none;
  }
  &:hover {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
    transition: 0.5s box-shadow;
  }
`;
